import { computed, ref, watch } from 'vue'
import { palettes } from './tokens'

// Motyw aplikacji: "system" (wg ustawień systemu), "light" albo "dark".
// Wybór zapisujemy w localStorage; data-theme na <html> ustawia też skrypt
// w public/index.html przed pierwszym malowaniem, żeby strona nie mignęła.
export const THEME_STORAGE_KEY = 'pl-theme'

export const THEME_MODES = [
  { value: 'system', label: 'Systemowy' },
  { value: 'light', label: 'Jasny' },
  { value: 'dark', label: 'Ciemny' }
]

const isMode = value => THEME_MODES.some(item => item.value === value)

function readMode() {
  try {
    const value = window.localStorage.getItem(THEME_STORAGE_KEY)
    return isMode(value) ? value : 'system'
  } catch (error) {
    return 'system'
  }
}

const media = typeof window !== 'undefined' && window.matchMedia
  ? window.matchMedia('(prefers-color-scheme: light)')
  : null

const mode = ref(readMode())
const systemLight = ref(Boolean(media && media.matches))
if (media) media.addEventListener('change', event => { systemLight.value = event.matches })

// Bez preferencji systemowej zostaje motyw ciemny (pierwotny wygląd Peakslog)
export const resolvedTheme = computed(() => {
  if (mode.value === 'system') return systemLight.value ? 'light' : 'dark'
  return mode.value
})

function applyTheme(theme, doc = document) {
  doc.documentElement.dataset.theme = theme
  let meta = doc.querySelector('meta[name="theme-color"]')
  if (!meta) {
    meta = doc.createElement('meta')
    meta.name = 'theme-color'
    doc.head.appendChild(meta)
  }
  meta.content = palettes[theme].bg.app
}

export function installThemeMode() {
  watch(resolvedTheme, theme => applyTheme(theme), { immediate: true })
}

export function setThemeMode(value) {
  if (!isMode(value)) return
  mode.value = value
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, value)
  } catch (error) {
    // tryb prywatny / zablokowany storage: wybór działa do końca sesji
  }
}

export function useColorScheme() {
  return { mode, theme: resolvedTheme, modes: THEME_MODES, setMode: setThemeMode }
}
